import { render, staticRenderFns } from "./sel-box.vue?vue&type=template&id=3660335a&scoped=true"
import script from "./sel-box.vue?vue&type=script&lang=js"
export * from "./sel-box.vue?vue&type=script&lang=js"
import style0 from "./sel-box.vue?vue&type=style&index=0&id=3660335a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3660335a",
  null
  
)

export default component.exports